import React from "react";
import Hero from "../components/Hero";
import HeaderNav from "../components/HeaderNav";
import Footer from "../components/Footer";
import { Analytics } from "@vercel/analytics/react";

const Disclaimer = () => {
  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <Analytics />
        <HeaderNav />
        <Hero>
          <div className="flex flex-col px-32 py-5 gap-7 h-full justify-center laptop">
            <div className="gap-3 flex">
              <p className="  text-white font-bold text-5xl">Read Our</p>
            </div>
            <p className="text-yellow-400 font-bold text-5xl">Disclaimer</p>
            <p className=" text-white font-normal text-xl w-2/3">
              Read carefully!
            </p>
          </div>
          <div className="flex flex-col px-5 md:px-10 py-5 gap-7 h-full phone justify-center z-50">
            <div className="flex gap-3 flex-wrap">
              <span className="text-white font-bold text-3xl sm:text-5xl md:w-screen">
                Read Our
              </span>

              <span className=" text-yellow-400 font-bold text-3xl sm:text-5xl ">
                Disclaimer
              </span>
            </div>
            <p className=" text-white font-normal sm:text-xl ">
              Read carefully!
            </p>
          </div>
        </Hero>
        <div className="flex w-screen items-center justify-center">
          <text className=" px-10 py-10 flex text-justify">
            At Green Luck Tips, which is the trading name of Green Luck Tips
            Services LTD, we are dedicated to protecting your privacy and
            ensuring that your personal information is safe. This privacy policy
            explains how we collect and use your information when you use our
            website. We may request your name, contact information (such as your
            email address and phone number), and date of birth. We may also
            gather additional information relevant to customer surveys and
            offers. This information is exclusively used to provide you with
            better service and improve our products and services. Occasionally,
            we may send you promotional emails and SMS messages about new
            products, special offers, or other interesting information. If you
            no longer want to receive these emails, you can contact us at
            info@greenlucktips.com. We are committed to ensuring the security of
            your information and have implemented appropriate physical,
            electronic, and managerial procedures to safeguard and protect the
            data we collect online. We will not sell, distribute, or lease your
            personal information to third parties unless required by law or with
            your consent. If you believe that any information we have collected
            is incorrect or incomplete, please get in touch with us, and we will
            promptly correct any errors. Under the Data Protection Laws, you may
            also request information on personal data we have on you. If you
            want to delete your Green Luck Tips account, please note that you
            will lose all associated data and content, including active
            subscriptions. However, you can still use Green Luck Tips services
            by registering with a new email address and phone number. We may
            revise this privacy policy periodically, and it is effective as of
            October 2023. Please check this page regularly for any updates.
          </text>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Disclaimer;
